// Default config fallback
const defaultConfig = {
  app: {
    name: "Mahjong Member Aus",
    version: "1.0.0",
    environment: "development",
  },
  localization: {
    remoteUrl:
      "https://d392t2kbzfe6yu.cloudfront.net/config/mobile-localization.json",
    timeout: 10000,
    supportedLanguages: ["en", "zh", "sc"],
    defaultLanguage: "en",
  },
  api: {
    baseUrl: "https://x4rau8a9vk.execute-api.ap-southeast-2.amazonaws.com/prod",
    timeout: 30000,
    retryAttempts: 3,
  },
  review: {
    underReview: true,
  },
  web: {
    comingSoon: false,
    socialMediaMap: [
      "https://www.youtube.com",
      "https://www.xiaohongshu.com",
      "https://www.instagram.com",
    ],
    localization: {
      zhHKRemoteUrl: "https://d392t2kbzfe6yu.cloudfront.net/config/zh-hk.json",
      zhCNRemoteUrl: "https://d392t2kbzfe6yu.cloudfront.net/config/zh-cn.json",
      zhENRemoteUrl: "https://d392t2kbzfe6yu.cloudfront.net/config/en-gb.json",
    },
    pdf: {
      latestNews:
        "https://d392t2kbzfe6yu.cloudfront.net/config/latest-news.pdf",
      onlineShop:
        "https://d392t2kbzfe6yu.cloudfront.net/config/online-shop.pdf",
      photoGallery:
        "https://d392t2kbzfe6yu.cloudfront.net/config/photo-gallery.pdf",
    },
  },
};

let configCache = null;

export const loadConfig = async () => {
  if (configCache) {
    return configCache;
  }

  try {
    // Try to load config from remote URL
    const remoteConfigUrl = defaultConfig.localization.remoteUrl.replace(
      "mobile-localization.json",
      "config.json"
    );
    const response = await fetch(remoteConfigUrl);
    if (response.ok) {
      configCache = await response.json();
      return configCache;
    }
  } catch (error) {
    console.warn("Failed to load remote config, using default config:", error);
  }

  // Fallback to default config
  configCache = defaultConfig;
  return configCache;
};

export const getConfig = () => {
  return configCache || defaultConfig;
};

export const isComingSoon = () => {
  const config = getConfig();
  return config.web?.comingSoon === true;
};

export const getPDFUrls = () => {
  const config = getConfig();
  return config.web?.pdf || {};
};

export const getAppUrls = () => {
  const config = getConfig();
  return {
    iosUrl: config.app?.iosUrl || "https://apps.apple.com",
    androidUrl: config.app?.androidUrl || "https://play.google.com",
  };
};
